import script from "./GiftRoomSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftRoomSteps.vue?vue&type=script&setup=true&lang=js"

import "./GiftRoomSteps.vue?vue&type=style&index=0&id=366ba8d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366ba8d7"]])

export default __exports__